import React from "react"
import { Filter } from "components/SVG"
import { color } from "lib/theme/theme.css"
import {
  filterButton,
  filterButtonCopy,
  filterIcon,
  filterNumber,
} from "./PLPFilters.css"

type FilterButtonProps = {
  hasFilters: boolean
  filterCount: number
  onOpen: React.Dispatch<React.SetStateAction<boolean>>
  isOpen: boolean
}

export const PLPFilterButton: React.FC<FilterButtonProps> = ({
  hasFilters,
  filterCount,
  onOpen,
  isOpen,
}) => {
  const iconColour = hasFilters ? color.content : "transparent"

  return (
    <button
      type="button"
      className={filterButton}
      onClick={() => onOpen(true)}
      data-testid="filter-button-plp"
      aria-expanded={isOpen}
    >
      <span className={filterButtonCopy}>
        Filters{" "}
        {hasFilters && <span className={filterNumber}>[{filterCount}]</span>}
        <Filter fill={iconColour} className={filterIcon} />
      </span>
    </button>
  )
}
